module.exports = __webpack_public_path__ + "static/img/FeelischWolfgang_DripMusic_Garden_c1970.9733e57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/FeelischWolfgang_DripMusic_Garden_c1970.jpg
// module id = sGSq
// module chunks = 0